export default __webpack_public_path__ + "static/media/Lustra-Expert_rocket_DAO.b96fd410.svg";